import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["container", "template", "section", "destroy", "position"]

  connect() {
    this.sortable = Sortable.create(this.containerTarget, {
      handle: "[data-drag-handle]",
      animation: 150,
      ghostClass: "opacity-50",
      onEnd: () => this.updatePositions()
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.updatePositions()
  }

  remove(event) {
    event.preventDefault()

    const section = event.target.closest("[data-nested-sections-target='section']")

    if (section) {
      const destroyField = section.querySelector("[data-nested-sections-target='destroy']")

      if (destroyField && destroyField.name.includes("[id]") === false) {
        // New record that hasn't been saved - just remove the DOM element
        const idField = section.querySelector("input[name*='[id]']")
        if (!idField || !idField.value) {
          section.remove()
          this.updatePositions()
          return
        }
      }

      if (destroyField) {
        destroyField.value = "1"
        section.style.display = "none"
      }
    }

    this.updatePositions()
  }

  updatePositions() {
    const visibleSections = this.sectionTargets.filter(section => section.style.display !== "none")

    visibleSections.forEach((section, index) => {
      const positionField = section.querySelector("[data-nested-sections-target='position']")
      if (positionField) {
        positionField.value = index
      }
    })
  }
}
